import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const usePractitionerConsumptionDetailsMiniStyles = makeStyles({
  // ── Contenedor raíz del DrawerBody ─────────────────────────────────────
  body: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalM,
    width: '100%',
    boxSizing: 'border-box',
  },

  spinnerWrapper: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: tokens.spacingVerticalXXL,
    paddingBottom: tokens.spacingVerticalXXL,
  },

  // ── Zonas de tarjetas (misma paleta que RateDrawer) ────────────────────
  infoCard: {
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke2),
    ...shorthands.padding(tokens.spacingVerticalM, tokens.spacingHorizontalL),
    backgroundColor: tokens.colorNeutralBackground3,
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalS,
    overflow: 'hidden',
  },

  editCard: {
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    ...shorthands.border('1px', 'solid', tokens.colorBrandStroke2),
    ...shorthands.padding(tokens.spacingVerticalM, tokens.spacingHorizontalL),
    backgroundColor: tokens.colorNeutralBackground1,
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalM,
    overflow: 'hidden',
  },

  resultCard: {
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    ...shorthands.border('1px', 'solid', tokens.colorBrandStroke2),
    ...shorthands.padding(tokens.spacingVerticalM, tokens.spacingHorizontalL),
    backgroundColor: tokens.colorBrandBackground2,
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalS,
    overflow: 'hidden',
  },

  // ── Título de sección ─────────────────────────────────────────────────
  sectionTitle: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground3,
    lineHeight: tokens.lineHeightBase200,
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
  },

  // ── Cabecera de tarjeta con acción (botón a la derecha) ────────────────
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    columnGap: tokens.spacingHorizontalM,
  },

  // ── Grids de datos solo lectura ───────────────────────────────────────
  dataGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    columnGap: tokens.spacingHorizontalL,
    rowGap: tokens.spacingVerticalS,
  },

  dataItem: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalXXS,
    minWidth: 0,
    overflow: 'hidden',
  },

  dataLabel: {
    fontSize: tokens.fontSizeBase100,
    color: tokens.colorNeutralForeground3,
    lineHeight: tokens.lineHeightBase100,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  dataValue: {
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
    lineHeight: tokens.lineHeightBase300,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  dataValueAccent: {
    fontSize: tokens.fontSizeBase400,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorBrandForeground1,
    lineHeight: tokens.lineHeightBase400,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  dataValueMeta: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightRegular,
    color: tokens.colorNeutralForeground3,
  },

  // ── Advertencia del servidor ───────────────────────────────────────────
  warningBox: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalXXS,
    ...shorthands.padding(tokens.spacingVerticalS, tokens.spacingHorizontalM),
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    ...shorthands.border('1px', 'solid', '#f8cfa4'),
    backgroundColor: '#fdf1e4',
    color: '#a14f05',
  },

  // ── Cadena de cálculo del honorario ───────────────────────────────────
  feeTable: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: tokens.fontSizeBase300,
  },

  feeLabel: {
    ...shorthands.padding('4px', '0'),
    color: tokens.colorNeutralForeground2,
  },

  feeAmount: {
    ...shorthands.padding('4px', '0'),
    textAlign: 'right',
    fontVariantNumeric: 'tabular-nums',
    whiteSpace: 'nowrap',
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
  },

  feeDeduct: {
    color: '#a14f05',
    fontWeight: tokens.fontWeightRegular,
  },

  feeBaseRow: {
    borderTop: `1px solid ${tokens.colorNeutralStroke2}`,
  },

  feeResultRow: {
    borderTop: '2px solid #2e7d32',
    color: '#2e7d32',
  },

  feeNote: {
    color: '#a14f05',
  },

  // ── Panel inline de edición de monto ──────────────────────────────────
  amountEditorPanel: {
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke2),
    ...shorthands.padding(tokens.spacingVerticalM, tokens.spacingHorizontalM),
    backgroundColor: tokens.colorNeutralBackground2,
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalM,
    overflow: 'hidden',
  },

  editorActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: tokens.spacingHorizontalS,
  },

  fieldFull: {
    width: '100%',
    boxSizing: 'border-box',
  },

  // ── Settlement link area ───────────────────────────────────────────────
  settlementRow: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalXXS,
  },

  // ── Cotización: valor + tipo + botón ──────────────────────────────────
  rateMeta: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground3,
    lineHeight: tokens.lineHeightBase200,
  },

  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
});
